import React, { useEffect, useState } from "react";
import { Spin, Table, Tag, Button, Avatar } from "antd";
import { EditOutlined, DeleteOutlined, UserOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";

import "./Submissions.css";
import { SubmissionStatus } from "../../../common/utils";
import FileLink from "../FileLink";

const antIcon = <Spin size="large" />;

const ProfileImage = ({ src }) => {
  const [error, setError] = useState(false);

  if (!src || error) {
    return <Avatar size={50} icon={<UserOutlined />} />;
  }

  return <img src={src} alt="profile" width={50} height={50} style={{ borderRadius: "50%", objectFit: "cover" }} onError={() => setError(true)} />;
};

const Submissions = () => {
  const [status, setStatus] = useState(SubmissionStatus.PENDING);
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  const fetchApplicationsByStatus = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_MASTER}/team-application/status`
      );
      const data = await response.json();

      if (data.success) {
        setApplications(data.data);
      }

      console.log(data);
    } catch (error) {
      console.log(error.response);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchApplicationsByStatus();
  }, []);

  const fetchApplicationsWithoutLoading = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_MASTER}/team-application/status`
      );
      const data = await response.json();

      if (data.success) {
        setApplications(data.data);
      }

      console.log(data);
    } catch (error) {
      console.log(error.response);
    }
  };

  const triggerDelete = async (id) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_MASTER}/team-application/${id}`,
        {
          method: "DELETE",
        }
      );

      await response.json();
      await fetchApplicationsWithoutLoading();
    } catch (error) {
      console.log(error.response);
    }
  };

  const columns = [
    {
      title: "Profile Image",
      dataIndex: "profile",
      key: "profile",
      render: (text) => <ProfileImage src={text} />,
    },
    {
      title: "Full Name",
      dataIndex: "fullName",
      key: "fullName",
    },
    {
      title: "Email Address",
      dataIndex: "emailAddress",
      key: "emailAddress",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Position",
      dataIndex: "position",
      key: "position",
    },
    {
      title: "Resume",
      dataIndex: "resume",
      key: "resume",
      // The resume is optional on the public form, so a row can legitimately
      // have none. A link to nothing is worse than saying so.
      render: (text) => <FileLink url={text} label="Download Resume" />,
    },
    {
      title: "Cover Letter",
      dataIndex: "coverLetter",
      key: "coverLetter",
      render: (text, record) => (
        <FileLink
          url={text}
          label="Download Cover Letter"
          fileName={record.coverLetterName}
        />
      ),
    },
    {
      title: "Date Applied",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      defaultSortOrder: "descend",
      render: (text) => (text ? new Date(text).toLocaleDateString() : "N/A"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        let color = "geekblue";
        if (text === SubmissionStatus.PENDING) {
          color = "orange";
        } else if (text === "COMPLETED") {
          color = "green";
        } else if (text === "REJECTED") {
          color = "red";
        }
        return (
          <Tag color={color} key={text}>
            {text.toUpperCase()}
          </Tag>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div style={{ display: "flex", gap: 8, whiteSpace: "nowrap" }}>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => history.push(`/ambassadors/${record.id}`)}
          >
            Edit
          </Button>
          <Button
            type="primary"
            danger
            icon={<DeleteOutlined />}
            onClick={() => triggerDelete(record.id)}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <Table
        dataSource={applications}
        columns={columns}
        scroll={{ x: "max-content" }}
        pagination={false}
        loading={{
          spinning: loading,
          indicator: <Spin indicator={antIcon} />,
        }}
        locale={{ emptyText: "No applications found" }}
      />
    </div>
  );
};

export default Submissions;
